export default "__VITE_ASSET__aa047ab3__"